export type ConversationalTranslationDirection = 'inbound' | 'outbound';

export const ConversationalTranslationStatus = {
  completed: 'completed',
  skipped: 'skipped',
  failed: 'failed'
} as const;

export type ConversationalTranslationStatus =
  (typeof ConversationalTranslationStatus)[keyof typeof ConversationalTranslationStatus];

export interface ProcessConversationalTranslationPayload {
  correlationId: string;
  pipeline: string;
  direction: ConversationalTranslationDirection;
  message: { id: string; text: string; contentHash: string };
  sender: { userId: string; languageTag: string | null; confidence: number | null };
  target: { userId: string; languageTag: string | null; confidence: number | null };
  /** Optional. When set, library uses this provisioned provider for the run. */
  provider?: string | null;
}

export interface ConversationalTranslationEntry {
  targetLanguageTag: string;
  sourceLanguageTag?: string;
  sourceLanguageConfidence?: number;
  content: string;
  confidence?: number;
  provider: string;
}

export interface ConversationalTranslationResult {
  correlationId: string;
  translationStatus: ConversationalTranslationStatus;
  entries: ConversationalTranslationEntry[];
  driverLanguageTag?: string;
  driverLanguageConfidence?: number;
  driverLanguageDetectionStatus?: string;
}

const warehouseCountryLanguageTags: Record<string, string> = {
  USA: 'en',
  CAN: 'en-CA',
  MEX: 'es-MX',
  BRA: 'pt-BR'
};

/** Maps warehouse ISO alpha-3 country to a BCP-47 tag. */
export function warehouseLanguageTagFromCountry(country?: string | null): string {
  if (!country) {
    return 'en';
  }
  return warehouseCountryLanguageTags[country] ?? 'en';
}
